import { memo, useCallback, useEffect, useState } from "react"
import { Form, Modal, Button, Row, Col, Card, Accordion } from "react-bootstrap";
import CloseIcon from "@mui/icons-material/CloseRounded";
import SaveIcon from "@mui/icons-material/SaveRounded";
import ApiAmusementServiceReserveItemTicketSources from "../../../../core/api/api.amusementServiceReserveItemTicketSources";
import { Box, Typography } from "@mui/material";
import { FormProvider, useForm } from "react-hook-form";
import SwalMessage from "../../_Components/SwalMessage";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import TicketRow from "./TicketRow";

const TicketSourceModal = ({ setTicketResourceManagment, selectedItem }) => {
  const [rowItems, setRowItems] = useState([])
  const [ticketSources, setTicketSources] = useState([])
  const [refresh, setRefresh] = useState(0)
  const methods = useForm({ defaultValues: { tickets: [] } })

  useEffect(() => {
    methods.reset()
    rowItems.forEach((row, index) => {
      methods.setValue(
        `tickets[${index}].basketItemPersonId`,
        selectedItem[index].id
      );
    });
  }, [rowItems, methods.setValue]);

  useEffect(() => {
    (async () => {
      const reposnse = await ApiAmusementServiceReserveItemTicketSources.getAllTicketsByBasketItemPersonIds({ basketItemPersonIds: selectedItem.map(item => item.id).join(",") })
      const reposnse2 = await ApiAmusementServiceReserveItemTicketSources.getAllAvailableTicketSources({ reserveItemId: selectedItem[0].amusementServiceReserveItemId })
      setRowItems(reposnse.data)
      setTicketSources(reposnse2.data)
    })()
  }, [refresh])

  const handleClose = useCallback(() => {
    setTicketResourceManagment(false)
  })

  const onSubmit = useCallback(async (data) => {
    data.tickets = data.tickets.map(item => ({ ...item, amusementServiceReserveItemTicketSourceId: item.amusementServiceReserveItemTicketSourceId == "SYSTEM_ASSIGN" ? null : item.amusementServiceReserveItemTicketSourceId }))
    try {
      let response = await ApiAmusementServiceReserveItemTicketSources.updateBasketItemPersonTicketSource(data)

      if (response.succeeded == true) {
        handleClose()
      }
      SwalMessage({ title: response.message, iSsuccess: response.succeeded });
    } catch (error) {
    }
  }, [])

  const onSubmitChangeStatus = useCallback(async () => {
    try {
      let response = await ApiAmusementServiceReserveItemTicketSources.updateStatusAmusementServiceReserveItemTicketSource({
        tickets: rowItems.map(item => ({ id: item.id, status: 3 }))
      })

      if (response.succeeded == true) {
        setRefresh(prev => prev + 1)
      }
      SwalMessage({ title: response.message, iSsuccess: response.succeeded });
    } catch (error) {
    }
  }, [rowItems]);

  return <Modal enforceFocus={false} centered dialogClassName="modal-90w"
    show={setTicketResourceManagment} onHide={handleClose}>
    <Modal.Header closeButton>
      <Modal.Title>
        مدیریت منبع بلیط
      </Modal.Title>
    </Modal.Header>
    <FormProvider {...methods}>
      <Form
        onSubmit={methods.handleSubmit(onSubmit)}
      >
        <Modal.Body>
          <Accordion className="mb-5" >
            <Accordion.Item eventKey="1" style={{ backgroundColor: "#f8fafc" }}>
              <Card style={{ backgroundColor: "#f8fafc" }}>
                <Accordion.Button as={Card.Header} className="px-5 py-4" variant="link">
                  <Card.Title style={{ fontSize: 12.5, color: '#334155', fontWeight: 600 }} className="p-0 w-100">
                    <InfoOutlinedIcon
                      sx={{ width: 20, height: 20, color: '#64748b', mt: '1px', flexShrink: 0, ml: 1 }}
                    />
                      راهنما
                </Card.Title>
                </Accordion.Button>
                <Accordion.Body className="p-0">
                  <Card.Body>
                    <ul>
                      <li className="mt-2">برای ثبت بلیط جدید ابتدا باید دقت کنید که تمامی بلیط ها در وضعیت <strong>معلق</strong> باشند.</li>
                      <li className="mt-2">اگر حتی یکی از بلیط ها در وضعیت معلق نبودند با استفاده از دکمه "تغییر وضعیت به تعلیق" وضعیت همه بلیط ها را به <strong>معلق</strong> تغییر دهید.</li>
                    </ul>
                  </Card.Body>
                </Accordion.Body>
              </Card>
            </Accordion.Item>
          </Accordion>
          {rowItems.map((row, index) => (
            <TicketRow
              key={`${row.id}_${index}`}
              row={row}
              index={index}
              control={methods.control}
              methods={methods}
              ticketSources={ticketSources}
              ticket={selectedItem[index]}
            />
          ))}
        </Modal.Body>
        <Modal.Footer>
          <Tippy
            content="تمامی بلیط ها در وضعیت معلق هستند"
            hideOnClick={false}
            disabled={!!rowItems.filter(row => !!row.status && row.status != 3).length}
          >
            <span>
              <Button
                disabled={!rowItems.filter(row => !!row.status && row.status != 3).length}
                variant="light-info"
                onClick={onSubmitChangeStatus}
                type="button"
              >
                <SaveIcon className="ms-1" />
          تغییر وضعیت به تعلیق
        </Button>
            </span>
          </Tippy>
          <Tippy
            content="ابتدا وضعیت تمامی بلیط ها را به معلق تغییر دهید"
            hideOnClick={false}
            disabled={!rowItems.filter(row => !!row.status && row.status != 3).length}
          >
            <span>
              <Button
                disabled={!!rowItems.filter(row => !!row.status && row.status != 3).length}
                variant="success"
                type="submit"
              >
                <SaveIcon />
            ثبت بلیط جدید
          </Button>
            </span>
          </Tippy>
          <Button variant="danger" onClick={handleClose}>
            <CloseIcon />
        بستن
      </Button>
        </Modal.Footer>
      </Form>
    </FormProvider>
  </Modal>
}

export default memo(TicketSourceModal)